import { IconsEnum } from "./IconEnum";

export const configuratorConstants = Object.freeze({
    electricVehicle: {
        consumption: 18, // e_verbrauch_e_car: Verbrauch E-Auto in kWh/100km
        maxAutonomy: 65, // max_autarkie_e_car: max. Autarkie E-Auto
        minYearlyConsumption: 500 // min_e_car_consum: Minimum Verbrauch E-Auto km/Jahr
    },

    photovoltaic: {
        dimensionFactor: 2, // dimensionsfaktor_pv: Budgetfaktor PV-Anlage für Erstkonfiguration
        maxSpecificYield: 940, // max_spec_yield: max. spezifischer Ertrag
        moduleSize: 2.0, // module_size: durchschnittl. Modulgröße in qm für ca. Werte Startseite
        modulePower: 0.395, // module_power: durchschnittl. Modulleistung in kWp für ca. Werte Startseite
        minModules: 7 // min_module: min. Module an Zusatz-WR
    },

    battery: {
        dimensionFactor: 0.9 // dimensionsfaktor_bat: Budgetfaktor Speichersystem für Erstkonfiguration
    },

    conventionalCar: {
        consumption: 6.0 // verbrauch_pkw: Verbrauch herkömml. Pkw mit Verbrenner L/100 km
    },

    autonomy: {
        maxHousehold: 80, // max_autarkie: max. Autarkie Hausstrom
        maxHeatPump: 55 // max_autarkie_wp: max. Autarkie Wärmepumpe
    },

    inverter: {
        hi5MaxPower: 7.5, // maxkw_hi5: max. AC-Nennl. Hi5
        hi10MaxPower: 16.0, // maxkw_hi10: max. AC-Nennl. Hi10
        minAdditionalPower: 2.95, // minkw_wr: min. Modullstg. Zusatz-WR
        hasTRE: 0, // is_tre: TRE vorhanden?
        useSolarEdge: 0 // sedge: Solaredge WR verwendet? Zugriffsindex für Array WR-Price (0=normale WR, 1=SolarEdge WR)
    },

    tax: {
        factor: 1.0, // mwst: Faktor Mehrwertsteuer
        rate: 0.0, // mwst_satz: Mehrwertsteuersatz
        text: '0 %', // mwst_txt: Mehrwertsteuersatz für AG-Text
        original: {
            factor: 1.0, // original_mwst: Original Faktor Mehrwertsteuer zum Zurücksetzten
            rate: 0.0, // original_mwst_satz: Original Mehrwertsteuersatz zum Zurücksetzten
            text: '0 %' // original_mwst_txt: Original Mehrwertsteuersatz für AG-Text zum Zurücksetzten
        },
        normal: {
            factor: 1.19, // normal_mwst: Faktor Mehrwertsteuersatz bei gewerbl. Anlagen
            rate: 19.0, // normal_mwst_satz: Mehrwertsteuersatz bei gewerbl. Anlagen
            text: '19 %' // normal_mwst_txt: Mehrwertsteuersatz für AG-Text bei gewerbl. Anlagen
        }
    },

    orderForm: {
        hasDistanceSelling: 0, // f_absatz: AB mit Fernabsatz ?
        listIndividualPrices: 0, // list_agpricee: Einzelpricee im AG auflisten?
        useNormalTaxRate: 0 // list_mwst: normaler Mehrwertsteuersatz bei gewerbl. Anlagen anwenden?
    },

    heatPump: {
        minYearlyConsumption: 500 // min_wp_consum: Minimum Verbrauch Wärmepumpe kWh/Jahr
    },

    financial: {
        residualValueFactor: 0.8, // faktor_resvalue: Faktor für Restwert
        residualValueInvestmentDiff: 0 // diff_resv2invest: Differenz Restwert nach 20 Jahren zu Anfangsinvestition
    },

    misc: {
        roofConfigChanged: 0, // roof_is_changed: Wurde die Konfig. d. Dächer geändert?
        roundingExponent: 1, // exponent: Exponent zum Auf- / Abrunden auf Zehnereinheiten Dachausrichtung
        defaultPackage: 'pv_packages_high'
    },

    subsidies: {
        nbankBatterySubsidyRatio: 0.4, // nb_bat_foerd: NBank Förderanteil an Speichersystem
        nbankBatteryPVRatio: 1.2, // nb_bat_ratio: Verhälnis PV zu Speicher um voll Fördersumme zu erhalten
        nbankPVBatteryConversionFactor: 0.8333333, // nb_pvbat_umrech: Umrechnungsfaktor max. Fördersumme
        nbankPVSubsidyAbove10kWp: 800 // nb_pv_foerd: Förderung NBank PV > 10 kWp einmailig
    },

    feedInTariff: {
        partial: {
            upTo10kWp: 0.0803, // refund_10: Vergütung bis 10 kWp
            upTo40kWp: 0.0695, // refund_40: Vergütung bis 40 kWp
            upTo100kWp: 0.0568, // refund_100: Vergütung bis 100 kWp
            other: 0.0646 // sonst_refund: Vergütung für sonstige Anlagen nach §48 Abs. 1, EEG 2023
        },
        full: {
            upTo10kWp: 0.1273, // refund_10_full: Vergütung bis 10 kWp
            upTo40kWp: 0.1068, // refund_40_full: Vergütung bis 40 kWp
            upTo100kWp: 0.1068, // refund_100_full: Vergütung bis 100 kWp
            other: 0.0646 // sonst_refund_full: Vergütung für sonstige Anlagen nach §48 Abs. 1, EEG 2023
        }
    },

    applicableValue: {
        partial: {
            upTo10kWp: 0.0843, // azw_10: anzulegender Wert bis 10 kWp
            upTo40kWp: 0.0735, // azw_40: anzulegender Wert bis 40 kWp
            upTo100kWp: 0.0608, // azw_100: anzulegender Wert bis 100 kWp
            upTo400kWp: 0.0608, // azw_400: anzulegender Wert bis 400 kWp
            upTo1000kWp: 0.0608, // azw_1000: anzulegender Wert bis 1000 kWp
            other: 0.0686 // sonst_azw: Vergütung für sonstige Anlagen nach §48 Abs. 1, EEG 2023
        },
        full: {
            upTo10kWp: 0.1313, // azw_10_full: anzulegender Wert bis 10 kWp
            upTo40kWp: 0.1108, // azw_40_full: anzulegender Wert bis 40 kWp
            upTo100kWp: 0.1108, // azw_100_full: anzulegender Wert bis 100 kWp
            upTo400kWp: 0.0921, // azw_400_full: anzulegender Wert bis 400 kWp
            upTo1000kWp: 0.0794, // azw_1000_full: anzulegender Wert bis 1000 kWp
            other: 0.0686 // sonst_azw_full: Vergütung für sonstige Anlagen nach §48 Abs. 1, EEG 2023
        }
    },

    energy: {
        averagePrice: 0.411, // energy_price: durchschnittlicher Stromprice/kWh über 20 Jahre inkl. 3% jährliche Strompriceerhöhung in Euro (obsolete, da über Formular berechnet)
        systemLossFactor: 0.97, // lossfactor_sys: Faktor Anlagenverlust durch Kabel, Sicherungen, Zähler...
        yearlyOperatingCosts: 0 // betr_kost: jährlich Betriebskosten (Summe aus: Grundgebühr + Cloudgebühr + Wartung + Reparatur + ...)
    },

    maxPower: {
        s5: 6.4, // maxkW_S5
        t10: 13.0 // maxkW_T10
    },

    alphaValues: {
        b3: 0, // gv_alpha_b3
        s5: 0, // gv_alpha_s5
        t10: 0 // gv_alpha_t10
    }
});

export const enum ConfiguratorThemeTypes {
    LOGO_LIGHT = "logoLight",
    LOGO_DARK = "logoDark",
    BACKGROUND = "background",
    FAVICON = "favicon"
}


export type FeedInTariffTier = {
    upperLimit: number;
    rate: number;
};

export type FeedInTariffConfig = {
    refundTiers: FeedInTariffTier[];
    azwTiers: FeedInTariffTier[];
    sonstAzw: number;
};

export type FeedInTariffSettings = {
    partial: FeedInTariffConfig;
    full: FeedInTariffConfig;
};

export const defaultFeedInTariffSettings: FeedInTariffSettings = {
    partial: {
        refundTiers: [
            { upperLimit: 10, rate: 0.0778 },
            { upperLimit: 40, rate: 0.0673 },
            { upperLimit: 100, rate: 0.0550 },
        ],
        azwTiers: [
            { upperLimit: 10, rate: 0.0843 },
            { upperLimit: 40, rate: 0.0735 },
            { upperLimit: 100, rate: 0.0608 },
            { upperLimit: 400, rate: 0.0608 },
            { upperLimit: 1000, rate: 0.0608 },
        ],
        sonstAzw: 0.0686,
    },
    full: {
        refundTiers: [
            { upperLimit: 10, rate: 0.1234 },
            { upperLimit: 40, rate: 0.1035 },
            { upperLimit: 100, rate: 0.1035 },
        ],
        azwTiers: [
            { upperLimit: 10, rate: 0.1313 },
            { upperLimit: 40, rate: 0.1108 },
            { upperLimit: 100, rate: 0.1108 },
            { upperLimit: 400, rate: 0.0921 },
            { upperLimit: 1000, rate: 0.0794 },
        ],
        sonstAzw: 0.0686,
    },
};

export type ConfiguratorConstants = {
    maxDiscount?: number;
    duration?: number;
    minDuration?: number | null;
    maxDuration?: number | null;
    inflation?: number;
    minInflation?: number | null;
    maxInflation?: number | null;
    currentPrice?: number;
    minCurrentPrice?: number | null;
    maxCurrentPrice?: number | null;
    priceIncreaseRate?: number;
    minPriceIncreaseRate?: number | null;
    maxPriceIncreaseRate?: number | null;
    showInterestRate?: boolean;
    feedInTariffSettings?: FeedInTariffSettings;
};

export const enum ConfiguratorConstantsKeys {
    MAX_DISCOUNT = "maxDiscount",
    DURATION = "duration",
    MIN_DURATION = "minDuration",
    MAX_DURATION = "maxDuration",
    INFLATION = "inflation",
    MIN_INFLATION = "minInflation",
    MAX_INFLATION = "maxInflation",
    CURR_ENERGY_PRICE = "currentPrice",
    MIN_CURR_ENERGY_PRICE = "minCurrentPrice",
    MAX_CURR_ENERGY_PRICE = "maxCurrentPrice",
    PRICE_INCREASE_RATE = "priceIncreaseRate",
    MIN_PRICE_INCREASE_RATE = "minPriceIncreaseRate",
    MAX_PRICE_INCREASE_RATE = "maxPriceIncreaseRate",
    SHOW_INTEREST_RATE = "showInterestRate",
    FEED_IN_TARIFF_SETTINGS = "feedInTariffSettings",
}

export const enum ConfiguratorStepsNamesEnum {
    CONSUMPTION = 'consumption',
    CHARACTERISTICS = 'characteristics',
    ROOFS = 'roofs',
    LOCATION = 'location',
    COMPONENTS = 'components'
}

export const ConfiguratorSteps = [
    {
        name: ConfiguratorStepsNamesEnum.CONSUMPTION,
        icon: IconsEnum.POWER,
        showInFullFeedIn: false,
        displayName: 'configurator.titles.consumption'
    },
    {
        name: ConfiguratorStepsNamesEnum.CHARACTERISTICS,
        icon: IconsEnum.LIGHT_DARK,
        showInFullFeedIn: false,
        displayName: 'configurator.titles.characteristics'
    },
    {
        name: ConfiguratorStepsNamesEnum.ROOFS,
        icon: IconsEnum.ROOF,
        showInFullFeedIn: true,
        displayName: 'configurator.titles.roofs'
    },
    {
        name: ConfiguratorStepsNamesEnum.LOCATION,
        icon: IconsEnum.LOCATION,
        showInFullFeedIn: true,
        displayName: 'configurator.titles.location'
    },
    {
        name: ConfiguratorStepsNamesEnum.COMPONENTS,
        icon: IconsEnum.SOLAR_PANEL,
        showInFullFeedIn: true,
        displayName: 'configurator.titles.components'
    }
]